/* iEDM Size Finder — shared core (data + calculator + reusable UI mount).
   Used by BOTH the size-charts page section and the PDP size-guide modal.
   The S dataset and every calculator function below are ported VERBATIM from
   iedm-size-widget-v2.html. Do not re-derive, recompute, round, or rename.
   cm is always computed from inches at render time (never hardcoded).
   Only the rendering was refactored from a single fixed-id IIFE into a
   per-instance mount() so the same data/logic can drive multiple placements. */
(function () {
  "use strict";
  if (window.IEDMSizeFinder) return;

  /* ===================== VERBATIM DATA + LOGIC ===================== */
  var LM = ["XS", "S", "M", "L", "XL", "2XL", "3XL", "4XL", "5XL"];
  var LW = ["XXS", "XS", "S", "M", "L", "XL", "2XL", "3XL"];

  /* ---- finalized data (inches). rows keyed by measurement name ---- */
  var S = {
    "mens-tee": { label: "Men's Tee", fam: "shirt", g: "m", snug: 0, driver: "Chest", sizes: ["S", "M", "L", "XL", "2XL", "3XL"],
      rows: { Chest: [19, 20.5, 22, 24, 26, 27.5], Length: [29, 30, 31, 32, 33, 34] } },
    "graphic-tee": { label: "Graphic Tee", fam: "shirt", g: "m", snug: 0, driver: "Chest", sizes: ["S", "M", "L", "XL", "2XL", "3XL", "4XL", "5XL"],
      rows: { Chest: [18, 20, 22, 24, 26, 28, 30, 32], Length: [28, 29, 30, 31, 32, 33, 34, 35] } },
    "long-sleeve": { label: "Long Sleeve", fam: "shirtLS", g: "m", snug: 0, driver: "Chest", sizes: ["XS", "S", "M", "L", "XL", "2XL", "3XL"],
      rows: { Chest: [17.5, 18.5, 19.5, 20.5, 21.5, 22.5, 23.5], Length: [28, 29, 30, 31, 32, 33, 34] } },
    "graphic-tee-ls": { label: "Graphic Tee Long Sleeve", fam: "shirtLS", g: "m", snug: 0, driver: "Chest", sizes: ["S", "M", "L", "XL", "2XL", "3XL"],
      rows: { Chest: [19.75, 20.75, 21.75, 23.25, 24.75, 26.25], Length: [28.75, 29.75, 30.75, 31.75, 32.75, 33.75], Sleeve: [25.5, 26, 26.5, 27, 27.5, 28] } },
    "mens-tank": { label: "Men's Tank", fam: "tank", g: "m", snug: 1, driver: "Width", sizes: ["S", "M", "L", "XL", "2XL", "3XL"],
      rows: { Width: [15.75, 17.5, 18.75, 20.5, 22, 23.5], Height: [27.25, 28, 29.125, 29.75, 31, 32] } },
    "muscle-tank": { label: "Muscle Tank", fam: "tank", g: "m", snug: 1, driver: "Chest", sizes: ["S", "M", "L", "XL", "2XL"],
      rows: { Chest: [19.13, 20.13, 21.13, 22.13, 23.13], Length: [30.25, 31.25, 32.25, 33.25, 34.25] } },
    "crew-sweater": { label: "Crew Sweater", fam: "shirtLS", g: "m", snug: 1, driver: "Width", sizes: ["XS", "S", "M", "L", "XL", "2XL"],
      rows: { Width: [19, 20.375, 21.25, 23.125, 24.5, 25.875], Height: [27.5, 28.75, 29.75, 30.75, 31.75, 33] } },
    "pullover-hoodie": { label: "Pullover Hoodie", fam: "hoodie", g: "m", snug: 1, driver: "Width", sizes: ["XS", "S", "M", "L", "XL", "2XL"],
      rows: { Width: [17.75, 19.25, 20.75, 22.75, 24.75, 26.75], Height: [24.5, 25.5, 26.75, 27.75, 29, 30] } },
    "zip-hoodie": { label: "Zip-Up Hoodie", fam: "hoodieZip", g: "m", snug: 1, driver: "Width", sizes: ["XS", "S", "M", "L", "XL", "2XL"],
      rows: { Width: [17.5, 19.25, 20.75, 22.75, 24.75, 26.75], Height: [23.5, 25, 25.75, 28.25, 29.75, 31.75] } },
    "hawaiian": { label: "Hawaiian / Lounge Shirt", fam: "camp", g: "m", snug: 0, driver: "Width", sizes: ["XS", "S", "M", "L", "XL", "2XL"],
      rows: { Width: [18.5, 20.125, 22.125, 24.125, 26.125, 28.125], Sleeve: [9.75, 10.25, 10.75, 11.25, 11.75, 12.25] } },
    "bomber": { label: "Bomber Jacket", fam: "jacket", g: "m", snug: 0, driver: "Chest", sizes: ["XS", "S", "M", "L", "XL", "2XL", "3XL"],
      rows: { Chest: [21, 22, 23, 24, 25.5, 27, 28.5], Length: [26.25, 27.25, 28.25, 29.25, 30.75, 32.25, 33.75], Waist: [20, 21, 22, 23, 24.5, 26, 27.5] } },
    "cloak": { label: "Cloak Zip", fam: "jacket", g: "m", snug: 0, driver: "Chest", sizes: ["XS", "S", "M", "L", "XL", "2XL", "3XL"],
      rows: { Chest: [20.38, 21.38, 22.38, 23.38, 24.88, 26.38, 27.88], Length: [32.5, 33.5, 34.5, 35.5, 37, 38.5, 40], Waist: [21.13, 22.13, 23.13, 24.13, 25.63, 27.13, 28.63] } },
    "onesie": { label: "Onesie", fam: "onesie", g: "m", snug: 0, driver: "Chest", sizes: ["S", "M", "L", "XL", "2XL"],
      rows: { Length: [60, 61, 62, 63, 64], Chest: [20, 21, 22, 23.5, 25], Waist: [19.5, 20.5, 21.5, 23, 24.5], Torso: [32, 33, 34, 35, 37] } },
    "crop-top": { label: "Crop Top", fam: "crop", g: "w", snug: 0, driver: "Chest", sizes: ["XS", "S", "M", "L", "XL", "2XL", "3XL"],
      rows: { Chest: [15.5, 16.5, 17.5, 18.5, 19.5, 20.5, 21.5], Length: [16.125, 16.625, 17.125, 17.625, 18.25, 18.75, 19.375] } },
    "crop-tee": { label: "Crop Tee", fam: "crop", g: "w", snug: 0, driver: "Chest", sizes: ["XS", "S", "M", "L", "XL", "2XL"],
      rows: { Chest: [15, 15.5, 16, 16.5, 17, 17.5], Length: [18, 18.5, 19, 19.75, 20.5, 21.25] } },
    "racerback": { label: "Racerback Tank", fam: "racer", g: "w", snug: 0, driver: "Chest", sizes: ["XS", "S", "M", "L", "XL", "2XL"],
      rows: { Chest: [14.5, 15.5, 16.5, 17.5, 18.5, 19.5], Length: [25.25, 26.25, 27.25, 28.25, 29.25, 30.25], Waist: [14.88, 15.88, 16.88, 17.88, 18.88, 19.88] } },
    "sports-bra": { label: "Sports Bra", fam: "bra", g: "w", snug: 0, driver: "Width", sizes: ["XS", "S", "M", "L", "XL", "2XL"],
      rows: { Width: [10.75, 11.5, 12.25, 13.5, 14.5, 15.88], Length: [6, 6.25, 6.5, 6.75, 7, 7.5] } },
    "hoodie-crop": { label: "Crop Hoodie", fam: "hoodie", g: "w", snug: 0, driver: "Chest", sizes: ["XXS", "XS", "S", "M", "L", "XL"],
      rows: { Chest: [16.38, 17.5, 18.5, 19.5, 21.13, 22.63], Length: [15.63, 16.13, 16.88, 17.38, 17.88, 18.75] } },
    "hoodie-dress": { label: "Hoodie Dress", fam: "dress", g: "w", snug: 0, shift: -1, driver: "Chest", sizes: ["XS", "S", "M", "L", "XL", "2XL"],
      rows: { Chest: [21.25, 23.125, 24.125, 26.0625, 28.9375, 30.4375], Length: [28.75, 29.5, 30.3125, 31.875, 33.4375, 34.25], Sleeve: [23.375, 24.375, 24.8125, 25.75, 26.9375, 27.5] } },
    "bodycon": { label: "Bodycon Dress", fam: "dress", g: "w", snug: 0, driver: "Chest", sizes: ["XXS", "XS", "S", "M", "L", "XL", "2XL"],
      rows: { Chest: [11.63, 12.5, 13.38, 14.25, 15.13, 16.25, 17.38], Waist: [10.25, 11.13, 12, 12.88, 13.75, 14.88, 16], Length: [31.5, 32.5, 33.5, 34.5, 35.5, 36.5, 37.5] } },
    "swimsuit": { label: "Womens Swimsuit (one piece)", fam: "onepiece", g: "w", snug: 0, driver: "Chest", sizes: ["XS", "S", "M", "L", "XL", "2XL"],
      rows: { Chest: [11.88, 12.75, 13.63, 14.63, 15.63, 16.63], Waist: [11.38, 12.25, 13.13, 14.13, 15.13, 16.13], Length: [25.25, 26, 26.75, 27.5, 28.25, 29] } },
    "leggings": { label: "Leggings", fam: "pants", g: "w", snug: 0, driver: "Waist", sizes: ["XS", "S", "M", "L", "XL", "2XL"],
      rows: { Waist: [27, 29, 31, 33.5, 36.5, 39.5], Outseam: [38.25, 38.625, 39, 39.375, 39.75, 40.125] } },
    "hw-shorts": { label: "High-Waisted Shorts", fam: "shorts", g: "w", snug: 0, driver: "Waist", sizes: ["XS", "S", "M", "L", "XL", "2XL"],
      rows: { Waist: [27, 29, 31, 33.5, 36.5, 39.5], Outseam: [12.75, 13.125, 13.5, 13.875, 14.25, 14.625] } },
    "booty-shorts": { label: "Booty Shorts", fam: "brief", g: "w", snug: 0, driver: "Waist", flatWaist: true, sizes: ["S", "M", "L", "XL", "XXL"],
      rows: { Waist: [13.875, 14.25, 14.75, 15.875, 17.25], Height: [9.75, 9.875, 10, 10.25, 10.875] } },
    "joggers": { label: "Joggers", fam: "pants", g: "m", snug: 0, driver: "Waist", sizes: ["XS", "S", "M", "L", "XL", "2XL"],
      rows: { Waist: [27.5, 29.5, 31.5, 34, 36.5, 39], Inseam: [29.75, 30.25, 30.25, 30.37, 31, 31.12] } },
    "weekend-shorts": { label: "Weekend Shorts", fam: "shorts", g: "m", snug: 0, driver: "FitsWaist", equiv: true, sizes: ["XS", "S", "M", "L", "XL", "2XL"],
      rows: { "Fits waist": [28, 30, 32, 34, 36, 38], "Garment waist": [29.5, 31.5, 33.5, 35.5, 37.5, 39.5], Inseam: [4.375, 4.5, 4.75, 5.125, 5.625, 5.875] } },
    "swim-trunks": { label: "Swim Trunks", fam: "shorts", g: "m", snug: 0, driver: "FitsWaist", equiv: true, sizes: ["XS", "S", "M", "L", "XL", "2XL"],
      rows: { "Fits waist": [28, 30, 32, 34, 36, 38], "Garment waist (flat)": [14, 15, 16, 17, 18, 19], Inseam: [4.75, 4.75, 4.75, 5.125, 5.125, 5.125] } },
    "kids-hoodie": { label: "Kids Hoodie", fam: "hoodie", g: "kid", snug: 0, driver: "Chest", sizes: ["6", "8", "10", "12"],
      rows: { Length: [21.25, 22.25, 23.25, 24.25], Chest: [18, 19, 20, 21], Waist: [17.25, 18.25, 19.25, 20.25] } },
    "big-backpack": { label: "Big Backpack", fam: "bag", g: "bag", driver: null, sizes: ["S", "M", "L"],
      rows: { "Width": [4.1, 4.5, 5], "Length": [9.1, 9.8, 12], "Height": [10.6, 12.5, 15] } },
    "small-backpack": { label: "Small Backpack", fam: "bag", g: "bag", driver: null, sizes: ["One Size"],
      rows: { Length: [14], Width: [6], Height: [16] } },
    /* Added per owner instruction (2026-07-21) — the only permitted data change.
       Printify backpack products map here (neither existing bag chart matched their spec). */
    "printify-backpack": { driver: null, fam: "bag", g: "bag", label: "Backpack", rows: { Height: [17], Length: [12.5], Width: [5] }, sizes: ["One Size"] }
  };

  /* ---- units ---- (unit passed per instance; formulas verbatim) ---- */
  function toDisp(v, unit) { return unit === "in" ? (Math.round(v * 1000) / 1000) + '"' : (Math.round(v * 2.54 * 10) / 10) + "cm"; }
  function shortVal(v, unit) { return unit === "in" ? (Math.round(v * 10) / 10) + '"' : Math.round(v * 2.54) + "cm"; }

  /* ---- sizing engine ---- */
  function baseM(w, hin) {
    var i = w <= 110 ? 0 : w <= 135 ? 1 : w <= 160 ? 2 : w <= 185 ? 3 : w <= 215 ? 4 : w <= 245 ? 5 : w <= 280 ? 6 : w <= 320 ? 7 : 8;
    var h = hin <= 65 ? 0 : hin <= 68 ? 1 : hin <= 70 ? 2 : hin <= 72 ? 3 : hin <= 74 ? 4 : hin <= 76 ? 5 : 6;
    if (h > i + 1) i++;
    return i;
  }
  function baseW(w) { return w <= 104 ? 0 : w <= 119 ? 1 : w <= 134 ? 2 : w <= 152 ? 3 : w <= 172 ? 4 : w <= 192 ? 5 : w <= 214 ? 6 : 7; }
  function waistEst(w, g) { return g === "m" ? 28 + (w - 130) * 0.11 : 26 + (w - 110) * 0.11; }
  var BRA_STYLES = { "crop-top": 1, "crop-tee": 1, "racerback": 1, "sports-bra": 1 };
  function bandBase(b) { return b <= 30 ? 1 : b <= 32 ? 2 : b <= 34 ? 3 : b <= 36 ? 4 : b <= 38 ? 5 : b <= 40 ? 6 : 7; }
  var CUPADJ = { AA: 0, A: 0, B: 0, C: 0, D: 0, DD: 1, DDD: 1, G: 2, H: 2 };
  function braIndex(band, cup) { return bandBase(band) + (CUPADJ[cup] || 0); }
  var RUNS_SMALL = { "mens-tee": 1, "graphic-tee": 1, "crew-sweater": 1 };
  /* Copy-only mirror of RUNS_SMALL: selects the "Runs roomy." tip. The calculator
     counterpart is the per-style `shift` (see recommend); this table never feeds it. */
  var RUNS_ROOMY = { "hoodie-dress": 1 };
  /* Card-footer scope: the "Tanks and tees run snug." sentence prints only on the
     two charts the owner named. This set is EXPLICIT and owner-chosen — do NOT
     re-derive it from the labels (an earlier /tee|tank/i rule also matched
     graphic-tee, graphic-tee-ls, muscle-tank, crop-tee and racerback, which are
     deliberately OUT). Adding a key is a copy decision, not a data one.
     Copy-only, like RUNS_ROOMY: it never feeds recommend() or the chart. */
  var RUNS_SNUG = { "mens-tee": 1, "mens-tank": 1 };
  var NO_FIT = { "booty-shorts": 1, "hw-shorts": 1, "leggings": 1, "big-backpack": 1, "small-backpack": 1, "sports-bra": 1, "weekend-shorts": 1, "swim-trunks": 1, "printify-backpack": 1 };

  function recommend(key, wt, hin, fit, bra) {
    var st = S[key];
    if (!wt || !st.driver || st.g === "bag" || st.g === "kid") return null;
    var sizes = st.sizes, i;
    if (st.driver === "Waist") {
      var est = waistEst(wt, st.g); if (st.flatWaist) est = est / 2;
      var best = 1e9, idx = 0, arr = st.rows.Waist;
      for (i = 0; i < arr.length; i++) { var d = Math.abs(arr[i] - est); if (d < best) { best = d; idx = i; } }
      idx = Math.min(sizes.length - 1, Math.max(0, idx + fit));
      return { size: sizes[idx] };
    }
    if (st.driver === "FitsWaist") {
      var body = waistEst(wt, st.g), fw = st.rows["Fits waist"], b2 = 1e9, j = 0;
      for (i = 0; i < fw.length; i++) { var dd = Math.abs(fw[i] - body); if (dd < b2) { b2 = dd; j = i; } }
      j = Math.min(sizes.length - 1, Math.max(0, j + fit));
      return { size: sizes[j] };
    }
    // tops
    var ladder = st.g === "m" ? LM : LW;
    var uni;
    if (bra && BRA_STYLES[key]) {
      var bi = braIndex(bra.band, bra.cup);
      uni = (key === "sports-bra") ? bi + fit : Math.round((baseW(wt) + bi) / 2) + (st.snug || 0) + fit;
    } else {
      uni = (st.g === "m" ? baseM(wt, hin) : baseW(wt)) + (st.snug || 0) + fit;
    }
    var us = sizes.map(function (s) { return { s: s, u: ladder.indexOf(s) }; });
    var minU = Math.min.apply(null, us.map(function (a) { return a.u; }));
    var maxU = Math.max.apply(null, us.map(function (a) { return a.u; }));
    /* Per-style ladder offset. Distinct from `snug`, which is ALSO read as a copy flag
       (paintChart tip "Runs snug." and the result note "runs snug, already factored in.")
       — a negative snug would be truthy and print the opposite of what it means.
       `shift` is calculator-only and is applied BEFORE the clamp, so [minU, maxU] is
       exactly the set of sizes this style can emit — every listed size is reachable,
       including the smallest. Do NOT move it back after the clamp: that puts the
       effective ceiling at maxU + shift and silently makes the largest listed size
       unreachable. (LANE 9 deleted a per-style floor field that had held hoodie-dress
       off its own smallest row; the chart minimum IS the floor.) */
    uni = Math.min(maxU, Math.max(minU, uni + (st.shift || 0)));
    var pick = us[0], bd = 1e9;
    us.forEach(function (a) { var d = Math.abs(a.u - uni); if (d < bd) { bd = d; pick = a; } });
    return { size: pick.s };
  }

  /* ---- how-to-measure copy ---- */
  var MDESC = {
    "Chest": "Measured flat, across the chest one inch below the armhole (pit to pit).",
    "Width": "Measured flat, across the body at the underarm (pit to pit).",
    "Length": "From the highest point of the shoulder straight down to the hem.",
    "Height": "From the shoulder seam straight down to the hem.",
    "Sleeve": "From the shoulder seam along the top of the arm to the cuff.",
    "Waist": "Across the waistband, measured flat.",
    "Inseam": "Along the inner leg, from the crotch to the hem.",
    "Outseam": "Along the outer side, from the top of the waistband to the hem.",
    "Torso": "From the shoulder straight down to the crotch.",
    "Fits waist": "The natural waist measurement this size is cut to fit.",
    "Garment waist": "The garment waistband, measured flat.",
    "Garment waist (flat)": "The garment waistband measured flat (about half your body waist)."
  };
  function measureText(rowName, st) {
    var d = MDESC[rowName] || "";
    var hooded = st.fam === "hoodie" || st.fam === "hoodieZip" || st.fam === "cloak" || (st.fam === "dress" && st.rows.Sleeve);
    if ((rowName === "Height" || rowName === "Length") && hooded) d += " Does not include the hood.";
    if (st.g === "bag") {
      if (rowName === "Width") d = "Side to side across the front.";
      else if (rowName === "Height") d = "Top to bottom.";
      else if (rowName === "Length") d = "Front to back (depth).";
    }
    return d;
  }

  /* ---- dropdown grouping for the size-charts page (22 visible styles) ---- */
  var PAGE_GROUPS = [
    ["Womens tops", ["crop-top", "crop-tee", "racerback", "sports-bra"]],
    ["Womens dresses & swim", ["hoodie-dress", "swimsuit"]],
    ["Womens bottoms", ["leggings", "hw-shorts", "booty-shorts"]],
    ["Mens & unisex tops", ["mens-tee", "mens-tank", "muscle-tank", "crew-sweater", "pullover-hoodie", "zip-hoodie", "hawaiian"]],
    ["Mens bottoms", ["joggers", "weekend-shorts", "swim-trunks"]],
    // printify-backpack is intentionally omitted from the page dropdown (PDP target only,
    // until a Printify backpack product is live). It remains in S so PDPs can target it.
    ["Kids & bags", ["kids-hoodie", "big-backpack", "small-backpack"]]
  ];

  /* ===================== REUSABLE INSTANCE MOUNT ===================== */
  /* opts:
       selector : 'dropdown' (grouped page dropdown) | 'segment' (combo tabs) | 'none' (locked single)
       styles   : array of style keys to expose (required for 'segment'/'none'; ignored for 'dropdown')
       groups   : override page groups for 'dropdown' (defaults to PAGE_GROUPS)
       start    : initial style key (defaults to first available)
       intro    : show kicker/h1/lede header (default true)
       aliasMap : render-only size-label alias, e.g. {"2XL":"XXL","3XL":"XXXL"} (PDP only)  */
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]; }); }

  function mount(root, opts) {
    opts = opts || {};
    var selector = opts.selector || "dropdown";
    var aliasMap = opts.aliasMap || null;
    var intro = opts.intro !== false;
    function dLabel(s) { return (aliasMap && aliasMap[s]) || s; } // display-only alias for size labels

    // resolve the style set
    var groups = opts.groups || PAGE_GROUPS;
    var styleList;
    if (selector === "dropdown") {
      styleList = groups.reduce(function (a, gp) { return a.concat(gp[1]); }, []);
    } else {
      styleList = (opts.styles || []).filter(function (k) { return S[k]; });
    }
    if (!styleList.length) styleList = ["crop-top"];
    /* EMPTY-STATE SENTINEL. "" marks "no style chosen yet". It can never collide with a
       style key: every key of S is a non-empty string, so S[""] — and BRA_STYLES[""],
       NO_FIT[""], RUNS_SMALL[""] — are all undefined and every lookup fails closed to the
       empty branch. Only the 'dropdown' surface (the size-charts PAGE) may hold it.
       'segment' and 'none' (every PDP modal) keep today's styleList[0] fallback verbatim,
       so the modal cannot reach the empty state even if mounted with no valid key.
       The dropdown surface ALSO ignores opts.start. sections/size-finder.liquid hardcodes
       start:"crop-top" and that hardcoded preselection IS the bug being fixed; the section
       is outside this run's authorized file list, so the neutralization lives here. It is
       scoped to the dropdown branch only, so the modal's start:keys[0] is untouched. */
    var EMPTY = "";
    var allowEmpty = (selector === "dropdown");
    var cur = allowEmpty ? EMPTY : (opts.start && S[opts.start] ? opts.start : styleList[0]);
    if (cur !== EMPTY && styleList.indexOf(cur) < 0) cur = styleList[0];

    // per-instance state
    var st_fit = 0, st_unit = "in", st_hi = null;

    // ---- build shell ----
    root.classList.add("iedm-size");
    var selHtml = "";
    if (selector === "dropdown") {
      selHtml =
        '<div class="isf-field">' +
        '<label class="isf-lbl">Style</label>' +
        '<select class="isf-style">' +
        /* Placeholder: rendered FIRST and selected while nothing is chosen. It is
           disabled (so the browser can never auto-select it as a real value and the user
           can never re-pick it) but NOT hidden — it stays visible as a label. Its value is
           the EMPTY sentinel, so even a forced selection resolves to the empty state.
           This lives inside the selector === "dropdown" branch, which is the ONLY place
           <select class="isf-style"> is built — the modal never enters this branch. */
        '<option class="isf-style-ph" value="" disabled' + (cur === EMPTY ? " selected" : "") + '>Choose your style</option>' +
        groups.map(function (gp) {
          return '<optgroup label="' + esc(gp[0]) + '">' +
            gp[1].map(function (k) { return '<option value="' + k + '"' + (k === cur ? " selected" : "") + '>' + esc(S[k].label) + "</option>"; }).join("") +
            "</optgroup>";
        }).join("") +
        "</select></div>";
    }
    var segHtml = "";
    if (selector === "segment" && styleList.length > 1) {
      segHtml =
        '<div class="isf-garments seg" role="group" aria-label="Choose garment">' +
        styleList.map(function (k) { return '<button type="button" class="isf-garment" data-key="' + k + '" aria-pressed="' + (k === cur ? "true" : "false") + '">' + esc(S[k].label) + "</button>"; }).join("") +
        "</div>";
    }

    var introHtml = intro
      ? '<p class="kicker"><span class="brand">iEDM</span> · Size Finder</p>' +
        '<h1>Find the size that <span class="g">actually fits</span>.</h1>' +
        '<p class="lede">Pick a style and enter your height and weight for a recommended size, or just read the chart. Each measurement is explained so you know exactly where to measure.</p>'
      : "";

    // Card blocks. W5: the Size chart card renders FIRST, the Your fit recommender
    // SECOND — one reorder here applies to every surface (modal + size-charts page).
    // Painting keys off class selectors (not DOM order) so the order is presentation-only.
    var chartCardHtml =
      '<div class="card">' +
        '<div class="card-hd">' +
          '<h2 class="isf-chart-title">Size chart</h2>' +
          '<div class="unit" role="group" aria-label="Units"><button type="button" class="isf-unit-in" aria-pressed="true">in</button><button type="button" class="isf-unit-cm" aria-pressed="false">cm</button></div>' +
        '</div>' +
        '<div class="split">' +
          '<div class="guide">' +
            '<div class="isf-img img-slot" hidden></div>' +
            '<p class="kicker" style="margin-bottom:8px">How to measure</p>' +
            '<ul class="isf-measure measure-list"></ul>' +
            '<div class="tips isf-tips"></div>' +
          '</div>' +
          '<div class="tblwrap">' +
            '<div class="tbl-scroll"><table class="isf-table"><colgroup></colgroup><thead></thead><tbody></tbody></table></div>' +
            '<div class="equiv isf-equiv" style="display:none"></div>' +
          '</div>' +
        '</div>' +
      '</div>';
    var fitCardHtml =
      '<div class="card">' +
        '<div class="card-hd"><h2>Your fit</h2></div>' +
        '<div class="card-bd">' +
          // W6: .isf-fit-row is a CSS hook (no new element) so desktop alignment rules
          // (assets/size-finder.css @min-width:750px) scope ONLY to this fit-card row.
          '<div class="row isf-fit-row">' +
            selHtml +
            // W4: Height (ft+in) and Weight are wrapped in .isf-hw. On desktop the wrapper
            // is display:contents (zero layout effect — identical to before). On mobile it
            // becomes one flex row so ft, in and weight sit on a single line.
            // W6: at min-width:750px .isf-hw becomes a flex pair so Height+Weight stay one
            // aligned row and never split across wrapped lines.
            '<div class="isf-hw">' +
              '<div class="isf-field">' +
                '<label class="isf-lbl">Height</label>' +
                '<div class="row" style="gap:8px"><select class="isf-ft" aria-label="Feet"></select><select class="isf-in" aria-label="Inches"></select></div>' +
              '</div>' +
              '<div class="isf-field">' +
                '<label class="isf-lbl">Weight (lb)</label>' +
                '<input class="isf-wt" type="number" min="60" max="400" value="" placeholder="e.g. 170" inputmode="numeric">' +
              '</div>' +
            '</div>' +
            // W6: Bra size + Fit preference wrapped in .isf-bf. display:contents at all widths
            // by default (mobile layout byte-identical: bra-field/fit-field remain direct flex
            // children of .row via contents). At min-width:750px it becomes a flex pair so the
            // Fit control shares one aligned row with the Band+Cup selects (A2). The wrapper is
            // the only new element; it carries no paint of its own.
            '<div class="isf-bf">' +
              '<div class="isf-field isf-bra-field" hidden>' +
                '<label class="isf-lbl">Bra size (optional)</label>' +
                '<div class="row" style="gap:8px"><select class="isf-band" aria-label="Band size"></select><select class="isf-cup" aria-label="Cup size"></select></div>' +
              '</div>' +
              '<div class="isf-field isf-fit-field">' +
                '<label class="isf-lbl">Fit preference</label>' +
                '<div class="seg isf-seg" role="group" aria-label="Fit preference">' +
                  '<button type="button" data-fit="-1" aria-pressed="false">Tight</button>' +
                  '<button type="button" data-fit="0" aria-pressed="true">Standard</button>' +
                  '<button type="button" data-fit="1" aria-pressed="false">Loose</button>' +
                '</div>' +
              '</div>' +
            '</div>' +
          '</div>' +
          '<div class="result">' +
            '<div class="rbig isf-big">—</div>' +
            '<div class="rtext"><div class="sub isf-sub">Enter your height and weight for a recommended size.</div><div class="note isf-note"></div></div>' +
          '</div>' +
        '</div>' +
      '</div>';

    root.innerHTML =
      '<div class="inner">' +
      introHtml +
      segHtml +
      chartCardHtml +
      fitCardHtml +
      // Card footer. The measurements sentence is universal and stays literal here;
      // the "run snug" sentence is written into .isf-foot-snug by
      // buildStructure() so it tracks the SELECTED style, not the modal. Empty span
      // renders nothing, and its leading space (added with the text) reproduces the
      // original single-space sentence join byte for byte.
      '<p class="foot">Measurements are flat garment values in inches; centimeters are computed from inches.<span class="isf-foot-snug"></span></p>' +
      '</div>';

    // ---- element refs (scoped to root) ----
    var $ = function (sel) { return root.querySelector(sel); };
    var $$ = function (sel) { return root.querySelectorAll(sel); };
    var elFt = $(".isf-ft"), elIn = $(".isf-in"), elWt = $(".isf-wt");
    var elBand = $(".isf-band"), elCup = $(".isf-cup");
    var elStyle = $(".isf-style");

    // populate height/weight/bra selects
    for (var f = 4; f <= 7; f++) elFt.insertAdjacentHTML("beforeend", '<option value="' + f + '"' + (f === 5 ? " selected" : "") + ">" + f + " ft</option>");
    for (var ii = 0; ii < 12; ii++) elIn.insertAdjacentHTML("beforeend", '<option value="' + ii + '"' + (ii === 9 ? " selected" : "") + ">" + ii + " in</option>");
    elBand.insertAdjacentHTML("beforeend", '<option value="">Band</option>');
    [30, 32, 34, 36, 38, 40, 42, 44].forEach(function (b) { elBand.insertAdjacentHTML("beforeend", '<option value="' + b + '">' + b + "</option>"); });
    elCup.insertAdjacentHTML("beforeend", '<option value="">Cup</option>');
    ["AA", "A", "B", "C", "D", "DD", "DDD", "G", "H"].forEach(function (c) { elCup.insertAdjacentHTML("beforeend", '<option value="' + c + '">' + c + "</option>"); });

    // ---- render helpers (verbatim logic, alias applied to size labels only) ----
    // W3: chart rendering is split so toggles don't full-rebuild the table (which flashed
    // and could jump the card height). buildStructure() only runs when the STYLE changes
    // (different sizes/rows); unit and highlight changes go through refresh(), which mutates
    // existing <td>/<col>/<th> in place. Displayed output stays byte-equivalent to the old
    // single-pass paintChart — same toDisp/Fits-waist formatting, same .hit placement.
    /* ---- empty state (PAGE dropdown only; structurally unreachable from the modal) ----
       The chart card SHELL always stays rendered: the card, its header and the in/cm
       toggle keep their box geometry, so nothing pops in and nothing shifts down when the
       first style is picked. Only the .split BODY (how-to-measure column + table) is
       swapped for one prompt line. The prompt node is created lazily and removed again on
       the first real build, and .split's inline display is removed rather than blanked —
       so any surface that never enters the empty state (every PDP modal, and any dropdown
       mount after a selection) produces byte-identical DOM to before this change.
       Markup contract with assets/size-finder.css (append-only empty-state block):
         <div class="card isf-empty">
           <div class="card-hd"> ... h2.isf-chart-title + .unit (both buttons disabled) </div>
           <div class="card-bd"><p class="isf-empty-note">Choose your style …</p></div>
         </div>
       and, first child of select.isf-style: option.isf-style-ph[value=""][disabled][selected]. */
    var emptyOn = false, emptyBd = null;
    function setEmptyState(on) {
      if (on === emptyOn) return;          // no-op fast path: zero DOM touch when never empty
      emptyOn = on;
      var split = $(".split"), card = split ? split.parentNode : null;
      var unitIn = $(".isf-unit-in"), unitCm = $(".isf-unit-cm");
      if (on) {
        if (!emptyBd) {
          emptyBd = root.ownerDocument.createElement("div");
          emptyBd.className = "card-bd";
          emptyBd.innerHTML = '<p class="isf-empty-note">Choose your style to see its measurements.</p>';
        }
        if (card) { card.classList.add("isf-empty"); card.insertBefore(emptyBd, split); }
        if (split) split.style.display = "none";
        $(".isf-chart-title").textContent = "Size chart";
        // in/cm keeps its normal position and its existing NON-active styling (both
        // aria-pressed="false"); disabled makes it genuinely inert, and the CSS block
        // pins :disabled to the same non-active pill so nothing greys out.
        unitIn.setAttribute("aria-pressed", "false");
        unitCm.setAttribute("aria-pressed", "false");
        unitIn.disabled = true; unitCm.disabled = true;
      } else {
        if (card) card.classList.remove("isf-empty");
        if (emptyBd && emptyBd.parentNode) emptyBd.parentNode.removeChild(emptyBd);
        if (split) split.removeAttribute("style");
        unitIn.setAttribute("aria-pressed", st_unit === "in");
        unitCm.setAttribute("aria-pressed", st_unit === "cm");
        unitIn.disabled = false; unitCm.disabled = false;
      }
    }

    var builtKey = null; // the style key the table DOM was last built for
    function buildStructure() {
      // Style-scoped card footer. buildStructure() is the one place that runs on
      // every style change (paintChart: builtKey !== cur), so the sentence follows
      // the garment segment in a combo modal. Written BEFORE the empty-state early
      // return so cur === EMPTY clears it (RUNS_SNUG[""] is undefined).
      $(".isf-foot-snug").textContent = RUNS_SNUG[cur] ? " Tanks and tees run snug. Between sizes, size up." : "";
      var st = S[cur];
      if (!st) { setEmptyState(true); builtKey = cur; return; }
      setEmptyState(false);
      $(".isf-chart-title").textContent = st.label + " — Size chart";
      $(".isf-measure").innerHTML = Object.keys(st.rows).map(function (rn) { return '<li><span class="mname">' + rn + "</span>" + measureText(rn, st) + "</li>"; }).join("");
      var sizes = st.sizes, rowNames = Object.keys(st.rows);
      var t = $(".isf-table");
      t.querySelector("colgroup").innerHTML = "<col>" + sizes.map(function () { return '<col>'; }).join("");
      t.querySelector("thead").innerHTML = "<tr><th></th>" + sizes.map(function (s) { return '<th>' + esc(dLabel(s)) + "</th>"; }).join("") + "</tr>";
      t.querySelector("tbody").innerHTML = rowNames.map(function (rn) {
        return "<tr><th>" + rn + "</th>" + sizes.map(function (s, i) {
          var v = st.rows[rn][i];
          var disp = (rn === "Fits waist") ? Math.round(v) + '"' : toDisp(v, st_unit);
          return '<td>' + disp + "</td>";
        }).join("") + "</tr>";
      }).join("");
      var eq = $(".isf-equiv");
      if (st.equiv) { eq.style.display = "block"; eq.innerHTML = "<b>Waist sizing:</b> 28=XS, 30=S, 32=M, 34=L, 36=XL, 38=2XL. Match your jeans waist to the number."; }
      else eq.style.display = "none";
      var tip;
      if (st.snug) tip = "<b>Runs snug.</b> Fits close to the body; size up 1 to 2 for a relaxed fit.";
      else if (cur === "pullover-hoodie" || cur === "zip-hoodie") tip = "<b>Unisex fit.</b> If you’re going by your usual size instead of this chart, men size up one and women size down one.";
      else if (RUNS_SMALL[cur]) tip = "<b>Runs small.</b> This style isn’t cut to standard sizing — if you’re going by your usual size instead of this chart, size up one.";
      else if (st.fam === "pants" || st.fam === "shorts" || st.fam === "brief") tip = "<b>Go by your waist.</b> Between sizes, size up.";
      else if (st.g === "bag") tip = "Dimensions are approximate; see the table for width, length (depth), and height.";
      else if (st.g === "kid") tip = "<b>Kids sizing.</b> Choose by the child’s chest and height.";
      else if (RUNS_ROOMY[cur]) tip = "<b>Runs roomy.</b> Between sizes, size down.";
      else tip = "<b>True to size.</b> Between sizes, size up.";
      if (st.fam === "hoodie" || st.fam === "hoodieZip") tip += " Height is measured from the shoulder to the hem and does not include the hood.";
      if (cur === "hawaiian") tip += " Chart shows chest width and sleeve length.";
      $(".isf-tips").innerHTML = tip;
      builtKey = cur;
    }
    // In-place: update cell VALUES (unit) + .hit highlight on the already-built table.
    function refresh() {
      var st = S[builtKey];
      if (!st) return; // empty state: no table was built, so there are no cells to update
      var sizes = st.sizes, rowNames = Object.keys(st.rows);
      var hitIdx = st_hi ? sizes.indexOf(st_hi) : -1;
      var t = $(".isf-table"), i;
      var cols = t.querySelectorAll("colgroup col");   // [0]=measure col, [i+1]=size i
      var ths = t.querySelectorAll("thead th");        // [0]=empty, [i+1]=size i
      for (i = 0; i < sizes.length; i++) {
        if (cols[i + 1]) cols[i + 1].classList.toggle("hit", i === hitIdx);
        if (ths[i + 1]) ths[i + 1].classList.toggle("hit", i === hitIdx);
      }
      var trs = t.querySelectorAll("tbody tr");         // one per row name; td[i]=size i
      for (var r = 0; r < rowNames.length; r++) {
        var rn = rowNames[r], tds = trs[r] ? trs[r].querySelectorAll("td") : [];
        for (i = 0; i < sizes.length; i++) {
          var td = tds[i]; if (!td) continue;
          var v = st.rows[rn][i];
          var disp = (rn === "Fits waist") ? Math.round(v) + '"' : toDisp(v, st_unit);
          if (td.textContent !== disp) td.textContent = disp;
          td.classList.toggle("hit", i === hitIdx);
        }
      }
    }
    function paintChart() {
      if (builtKey !== cur) buildStructure();
      refresh();
    }

    function setResult(big, sub, note) {
      $(".isf-big").textContent = big;
      $(".isf-sub").textContent = sub;
      $(".isf-note").textContent = note;
    }

    function paintCalc() {
      var wt = +elWt.value || 0;
      var hin = (+elFt.value) * 12 + (+elIn.value);
      var st = S[cur];
      var band = +elBand.value || 0, cup = elCup.value || "";
      var bra = (BRA_STYLES[cur] && band && cup) ? { band: band, cup: cup } : null;
      // No style chosen yet (dropdown surface only): "Your fit" keeps its shipped default
      // copy, exactly as it reads today before any height/weight is entered.
      if (!st) { setResult("—", "Enter your height and weight for a recommended size.", ""); st_hi = null; paintChart(); return; }
      if (st.g === "bag") { setResult("—", "This item isn’t sized by body measurements.", ""); st_hi = null; paintChart(); return; }
      if (st.g === "kid") { setResult("—", "Kids sizes go by the child’s age, chest, and height — see the chart.", ""); st_hi = null; paintChart(); return; }
      var r = recommend(cur, wt, hin, st_fit, bra);
      if (!r) { setResult("—", "Enter your height and weight for a recommended size.", ""); st_hi = null; paintChart(); return; }
      st_hi = r.size;
      var driverRow = st.driver === "FitsWaist" ? "Fits waist" : (st.rows[st.driver] ? st.driver : Object.keys(st.rows)[0]);
      var idx = st.sizes.indexOf(r.size), val = st.rows[driverRow] ? st.rows[driverRow][idx] : null;
      var sub = st.label + " · " + (driverRow === "Fits waist" ? ("fits ~" + Math.round(val) + '" waist') : (driverRow + " " + shortVal(val, st_unit) + (st.fam.indexOf("shirt") === 0 || st.fam === "tank" || st.fam === "crop" || st.fam === "hoodie" || st.fam === "hoodieZip" ? " flat" : "")));
      var fitWord = st_fit < 0 ? "a fitted" : "a relaxed";
      var note = st_fit === 0 ? "Standard fit for your height and weight." : ("Adjusted for " + fitWord + " fit.");
      if (st.snug) note += " This style runs snug, already factored in.";
      if (st.driver === "Waist" || st.driver === "FitsWaist") note += " Estimated from weight; confirm with your waist for best accuracy.";
      if (bra) note += " Refined with your bra size (" + bra.band + bra.cup + ").";
      setResult(dLabel(r.size), sub, note);
      paintChart();
    }

    // ---- per-style field toggles ----
    function toggleBra() { $(".isf-bra-field").hidden = !BRA_STYLES[cur]; }
    function toggleFit() {
      var hide = !!NO_FIT[cur];
      $(".isf-fit-field").hidden = hide;
      if (hide) { st_fit = 0; Array.prototype.forEach.call($$(".isf-seg button"), function (x) { x.setAttribute("aria-pressed", x.dataset.fit === "0" ? "true" : "false"); }); }
    }

    // ---- events ----
    if (elStyle) elStyle.addEventListener("change", function (e) { cur = e.target.value; st_hi = null; toggleBra(); toggleFit(); paintCalc(); });
    Array.prototype.forEach.call($$(".isf-garment"), function (b) {
      b.addEventListener("click", function () {
        Array.prototype.forEach.call($$(".isf-garment"), function (x) { x.setAttribute("aria-pressed", "false"); });
        b.setAttribute("aria-pressed", "true");
        cur = b.dataset.key; st_hi = null; toggleBra(); toggleFit(); paintCalc();
      });
    });
    [elWt, elFt, elIn].forEach(function (el) { el.addEventListener("input", paintCalc); });
    [elBand, elCup].forEach(function (el) { el.addEventListener("change", paintCalc); });
    Array.prototype.forEach.call($$(".isf-seg button"), function (b) {
      b.addEventListener("click", function () {
        Array.prototype.forEach.call($$(".isf-seg button"), function (x) { x.setAttribute("aria-pressed", "false"); });
        b.setAttribute("aria-pressed", "true"); st_fit = +b.dataset.fit; paintCalc();
      });
    });
    function setUnit(u) {
      if (!S[cur]) return; // inert while no style is chosen — the toggle renders, but does nothing
      st_unit = u;
      $(".isf-unit-in").setAttribute("aria-pressed", u === "in");
      $(".isf-unit-cm").setAttribute("aria-pressed", u === "cm");
      paintChart();
    }
    $(".isf-unit-in").addEventListener("click", function () { setUnit("in"); });
    $(".isf-unit-cm").addEventListener("click", function () { setUnit("cm"); });

    toggleBra();
    toggleFit();
    paintChart();
  }

  window.IEDMSizeFinder = { S: S, recommend: recommend, mount: mount, PAGE_GROUPS: PAGE_GROUPS, LM: LM, LW: LW };
})();
